export default theme => ({
  centered: {
    textAlign: 'center',
  },
  timerWindow: {
    cursor: 'pointer',
    textAlign: 'center',
    width: '100%',
    border: '1px solid black',
    fontSize: '8rem',
  },
})



// WEBPACK FOOTER //
// ./src/components/BreakTimer/BreakTimer.styles.js